import React from 'react';

import PropTypes from 'prop-types';

import { ContactResultItem } from 'components/ExpertSearch/mtn/components/ContactResultItem/ContactResultItem';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './ContactPage.scss';

const contactShape = PropTypes.shape({
  name: PropTypes.string,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  email: PropTypes.string,
});
const sectionShape = PropTypes.shape({
  title: PropTypes.string,
  contacts: PropTypes.arrayOf(contactShape),
});
const PageSection = ({ title, data }) => (
  <div className="contact-section">
    {title && <SubTitle text={title} />}
    {data.contacts &&
      data.contacts.map((contact) => {
        const contactName = contact.name?.split('(')[0].trim() || contact.name;
        const contactWorkTitle = contact.name?.split('(')[1]?.trim()?.slice(0, -1) || '';

        return (
          <ContactResultItem
            key={contact.name || contact.email}
            title={contact.title ? `${contact.title}: ${contactName}` : contactName}
            phone={contact.phone}
            email={contact.email}
            contactWorkTitle={contactWorkTitle}
          />
        );
      })}
    {data.sections &&
      data.sections.map((section) => (
        <PageSection key={section.title} title={section.title} data={section} />
      ))}
  </div>
);

PageSection.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    contacts: PropTypes.arrayOf(contactShape),
    sections: PropTypes.arrayOf(sectionShape),
  }).isRequired,
};

export const ContactPage = ({ pageData }) => (
  <>
    <PageTitleSection title={pageData.title} notFramed />
    <div className="contact-page__content">
      {pageData.description && <p>{pageData.description}</p>}
      <PageSection data={pageData} />
    </div>
  </>
);

ContactPage.propTypes = {
  pageData: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    sections: PropTypes.arrayOf(sectionShape),
  }).isRequired,
};
